import { Table, Row, Col, Container } from "react-bootstrap";
import { UserDataContext } from "../components/UserDataContext";
import { useState, useEffect, useContext, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import AddContributor from "./AddContributor";
import "../components/button.css";
import Button from "@mui/material/Button";
import { marginBottom } from "../App";
import { marginTop } from "../App";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../components/theme";
import { apiRequest } from "../components/Config";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import { TextField } from "@mui/material";
import Alerts from "../components/Alerts";
import { Checkbox } from "@mui/material";

export default function ContributionsData() {
  const { userData } = useContext(UserDataContext);
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const [showRegister, setShowRegister] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [searchMode, setSearchMode] = useState(false);
  const [editingCell, setEditingCell] = useState(null); // { id, key }
  const [editValue, setEditValue] = useState("");
  const [text, setText] = useState("Pobieranie danych...");
  const [apiResponse, setApiResponse] = useState({});
  const [showApiResponse, setShowApiResponse] = useState(false);

  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "asc",
  });

  const [debtThreshold, setDebtThreshold] = useState("");
  const [selectedIds, setSelectedIds] = useState([]);

  const handleChange = (e) => {
    setEditValue(e.target.value);
  };

  const handleDoubleClick = (id, key, currentValue) => {
    setEditingCell({ id, key });
    setEditValue(currentValue);
  };

  const showMessage = (msg) => {
    setApiResponse(msg);
    setShowApiResponse(true);
    setTimeout(() => setShowApiResponse(false), 5000);
  };

  const handleBlur = async () => {
    if (!editingCell) {
      setApiResponse({
        title: "Błąd",
        severity: "error",
        info: "... komunikat błędu ...",
      });
      setShowApiResponse(true);
      return;
    }

    const messages = {
      200: {
        title: "Informacja",
        severity: "info",
        info: "Dane zaktualizowane.",
      },
      555: {
        title: "Błąd",
        severity: "error",
        info: "Nie udało się zaktualizować.",
      },
      556: {
        title: "Błąd",
        severity: "error",
        info: "Brak uprawnień do edycji!",
      },
      557: {
        title: "Błąd",
        severity: "error",
        info: "Taki email już istnieje!",
      },
    };

    setData((prev) =>
      prev.map((item) =>
        item.id === editingCell.id
          ? { ...item, [editingCell.key]: editValue }
          : item
      )
    );

    try {
      const response = await apiRequest("updatecontributions", "POST", {
        id: editingCell.id,
        fieldName: editingCell.key,
        value: editValue,
      });

      if (response?.error_msg && messages[response.error_msg]) {
        showMessage(messages[response.error_msg]);
      }
    } catch (error) {
      setApiResponse({
        title: "Błąd",
        severity: "error",
        info: "Wystąpił błąd.",
      });
      setShowApiResponse(true);
    } finally {
      setEditingCell(null);
      setEditValue("");
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleBlur();
    } else if (e.key === "Escape") {
      setEditingCell(null);
      setEditValue("");
    }
  };

  const fetchData = useCallback(async () => {
    try {
      const response = await apiRequest("getcontributions", "GET", {
        param: searchValue,
      });

      if (Array.isArray(response)) {
        setData(response);
        if (response.length === 0) {
          setText("Brak danych spełniających kryteria wyszukiwania...");
        }
      } else {
        console.error("Otrzymane dane nie są tablicą:", response);
        setData([]);
      }
    } catch (error) {
      console.log(error.message);
    }
  }, [searchValue]);

  useEffect(() => {
    if (userData) fetchData();
  }, [searchMode, userData, fetchData]);

  useEffect(() => {
    const fetchDataInner = async () => {
      try {
        const response = await apiRequest("getcontributions", "GET", {
          param: searchValue,
        });
        if (Array.isArray(response)) {
          setData(response);
        } else {
          console.error("Otrzymane dane nie są tablicą:", response.data);
          setData([]);
        }
        if (response.length === 0)
          setText("Brak danych spełniających kryteria wyszukiwania...");
      } catch (error) {}
    };

    if (userData) fetchDataInner();
  }, [searchMode, userData, searchValue]);

  const handleEditUser = (id) => {
    setShowRegister(false);
    navigate(`/edituser/${id}`);
  };

  const compareValues = (a, b, direction) => {
    const valA = isNaN(Number(a)) ? a?.toString().toLowerCase() : Number(a);
    const valB = isNaN(Number(b)) ? b?.toString().toLowerCase() : Number(b);

    if (valA < valB) return -1 * direction;
    if (valA > valB) return 1 * direction;
    return 0;
  };

  const sortedData = [...data].sort((a, b) => {
    if (!sortConfig.key) return 0;
    const direction = sortConfig.direction === "asc" ? 1 : -1;
    return compareValues(a[sortConfig.key], b[sortConfig.key], direction);
  });

  const requestSort = (key) => {
    console.log("sort: ", key);
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };
  const handleAddUser = () => {
    setShowRegister(!showRegister);
  };

  const handleSearch = (e) => {
    setSearchValue(e.target.value);
    if (e.target.value.length > 0) {
      setSearchMode(true);
    } else {
      setSearchMode(false);
    }
  };

  const parseNumber = (v) => {
    if (v === null || v === undefined || v === "") return NaN;
    const norm = String(v).replace(",", ".").trim();
    return Number(norm);
  };

  const handleThresholdChange = (e) => {
    const val = e.target.value;
    setDebtThreshold(val);
  };

  useEffect(() => {
    if (debtThreshold === "" || debtThreshold === null) {
      setSelectedIds([]);
      return;
    }
    const threshold = parseNumber(debtThreshold);
    if (Number.isNaN(threshold)) {
      setSelectedIds([]);
      return;
    }

    const matched = (data || [])
      .filter((item) => {
        const num = parseNumber(item.endcurrentyeardebt);
        return !Number.isNaN(num) && num > threshold;
      })
      .map((i) => i.id);

    setSelectedIds(matched);
  }, [debtThreshold, data]);

  const toggleCheckbox = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  return (
    <Container>
      {showApiResponse && (
        <Row style={{ marginTop }}>
          <Alerts data={apiResponse} />
        </Row>
      )}
      {showRegister && <AddContributor refreshData={fetchData} />}
      <ThemeProvider theme={theme}>
        <Row style={{ marginBottom }}>
          <Col xs={4} sm={3}>
            <Button variant="outlined" onClick={handleAddUser}>
              <SupportAgentIcon /> Dodaj osobę
            </Button>
          </Col>

          <Col xs={4} sm={3}>
            <h4>Składki</h4>
          </Col>
          <Col xs={12} sm={6} style={{ display: "flex", alignItems: "center" }}>
            <label style={{ marginRight: 8 }}>Zaznacz zaległość &gt;</label>
            <TextField
              type="number"
              size="small"
              value={debtThreshold}
              onChange={handleThresholdChange}
              placeholder="-100"
              inputProps={{ step: "1" }}
            />
            <div style={{ marginLeft: 12, color: "#666", fontSize: 12 }}>
              (zostaną zaznaczone wiersze z <b>Zaległość</b> &gt; wartości)
            </div>
          </Col>
        </Row>
      </ThemeProvider>

      <Table bordered hover>
        <thead>
          <tr>
            <th></th>
            <th className="td-centered" onClick={() => requestSort("id")}>
              ID
            </th>
            <th>
              <span style={{ display: "flex", alignItems: "center" }}>
                <SwapVertIcon
                  onClick={() => requestSort("fullname")}
                  style={{ cursor: "pointer", marginRight: "0.6em" }}
                />
                Nazwisko i imię
              </span>
            </th>
            <th>
              <span style={{ display: "flex", alignItems: "center" }}>
                <SwapVertIcon
                  onClick={() => requestSort("mail")}
                  style={{ cursor: "pointer", marginRight: "0.6em" }}
                />
                Email
              </span>
            </th>
            <th>
              <span style={{ display: "flex", alignItems: "center" }}>
                <SwapVertIcon
                  onClick={() => requestSort("circle")}
                  style={{ cursor: "pointer", marginRight: "0.6em" }}
                />
                Koło
              </span>
            </th>
            <th>
              <span style={{ display: "flex", alignItems: "center" }}>
                <SwapVertIcon
                  onClick={() => requestSort("birth")}
                  style={{ cursor: "pointer", marginRight: "0.6em" }}
                />
                Rok urodzin
              </span>
            </th>
            <th>
              <span style={{ display: "flex", alignItems: "center" }}>
                <SwapVertIcon
                  onClick={() => requestSort("notice")}
                  style={{ cursor: "pointer", marginRight: "0.6em" }}
                />
                Uwagi
              </span>
            </th>
            <th>
              <span style={{ display: "flex", alignItems: "center" }}>
                <SwapVertIcon
                  onClick={() => requestSort("startcurrentyear")}
                  style={{ cursor: "pointer", marginRight: "0.6em" }}
                />
                Początek br.
              </span>
            </th>
            <th>
              <span style={{ display: "flex", alignItems: "center" }}>
                <SwapVertIcon
                  onClick={() => requestSort("incomecurrentyear")}
                  style={{ cursor: "pointer", marginRight: "0.6em" }}
                />
                Wpłaty w br.
              </span>
            </th>
            <th>
              <span style={{ display: "flex", alignItems: "center" }}>
                <SwapVertIcon
                  onClick={() => requestSort("contribution")}
                  style={{ cursor: "pointer", marginRight: "0.6em" }}
                />
                Składka/m-c
              </span>
            </th>
            <th>
              <span style={{ display: "flex", alignItems: "center" }}>
                <SwapVertIcon
                  onClick={() => requestSort("endcurrentyeardebt")}
                  style={{ cursor: "pointer", marginRight: "0.6em" }}
                />
                Zaległość
              </span>
            </th>
          </tr>
        </thead>
        {sortedData.length > 0 && userData.userId ? (
          <tbody>
            {sortedData.map((item, index) => (
              <tr key={item.id}>
                <td className="td-centered">
                  <Checkbox
                    checked={!selectedIds.includes(item.id)}
                    onChange={() => toggleCheckbox(item.id)}
                    size="small"
                  />
                </td>
                <td className="td-centered">{index + 1}</td>
                <td>{item.fullname}</td>
                <td
                  onDoubleClick={() =>
                    handleDoubleClick(item.id, "mail", item.mail)
                  }
                >
                  {editingCell?.id === item.id && editingCell.key === "mail" ? (
                    <input
                      type="text"
                      value={editValue}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      onKeyDown={handleKeyDown}
                      autoFocus
                    />
                  ) : (
                    <b>{item.mail}</b>
                  )}
                </td>
                <td
                  onDoubleClick={() =>
                    handleDoubleClick(item.id, "circle", item.circle)
                  }
                >
                  {editingCell?.id === item.id &&
                  editingCell.key === "circle" ? (
                    //["KOŁO PRZY ODDZIALE PZITB", "KOŁO MŁODYCH", "KOŁO PSB BYTOM"],

                    <select
                      value={editValue}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      onKeyDown={handleKeyDown}
                      autoFocus
                    >
                      <option value="KOŁO PRZY ODDZIALE PZITB">
                        KOŁO PRZY ODDZIALE PZITB
                      </option>
                      <option value="KOŁO MŁODYCH">KOŁO MŁODYCH</option>
                      <option value="KOŁO PSB BYTOM">KOŁO PSB BYTOM</option>
                    </select>
                  ) : (
                    <b>{item.circle}</b>
                  )}
                </td>

                <td className="td-centered">{item.birth}</td>
                <td
                  onDoubleClick={() =>
                    handleDoubleClick(item.id, "notice", item.notice)
                  }
                >
                  {editingCell?.id === item.id &&
                  editingCell.key === "notice" ? (
                    <select
                      value={editValue}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      onKeyDown={handleKeyDown}
                      autoFocus
                    >
                      <option value="pracownik">pracownik</option>
                      <option value="emeryt">emeryt</option>
                      <option value="zwolniona 80">zwolniona 80</option>
                      <option value="zasłużony">zasłużony</option>
                    </select>
                  ) : (
                    <b>{item.notice}</b>
                  )}
                </td>
                <td
                  onDoubleClick={() =>
                    handleDoubleClick(
                      item.id,
                      "startcurrentyear",
                      item.startcurrentyear
                    )
                  }
                >
                  {editingCell?.id === item.id &&
                  editingCell.key === "startcurrentyear" ? (
                    <input
                      type="text"
                      value={editValue}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      onKeyDown={handleKeyDown}
                      autoFocus
                    />
                  ) : (
                    <b>{item.startcurrentyear}</b>
                  )}
                </td>
                <td
                  onDoubleClick={() =>
                    handleDoubleClick(
                      item.id,
                      "incomecurrentyear",
                      item.incomecurrentyear
                    )
                  }
                >
                  {editingCell?.id === item.id &&
                  editingCell.key === "incomecurrentyear" ? (
                    <input
                      type="text"
                      value={editValue}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      onKeyDown={handleKeyDown}
                      autoFocus
                    />
                  ) : (
                    <b>{item.incomecurrentyear}</b>
                  )}
                </td>
                <td
                  onDoubleClick={() =>
                    handleDoubleClick(
                      item.id,
                      "contribution",
                      item.contribution
                    )
                  }
                >
                  {editingCell?.id === item.id &&
                  editingCell.key === "contribution" ? (
                    <input
                      type="text"
                      value={editValue}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      onKeyDown={handleKeyDown}
                      autoFocus
                    />
                  ) : (
                    <b>{item.contribution}</b>
                  )}
                </td>
                <td
                  onDoubleClick={() =>
                    // fixed: pass the proper current value (endcurrentyeardebt)
                    handleDoubleClick(
                      item.id,
                      "endcurrentyeardebt",
                      item.endcurrentyeardebt
                    )
                  }
                >
                  {editingCell?.id === item.id &&
                  editingCell.key === "endcurrentyeardebt" ? (
                    <input
                      type="text"
                      value={editValue}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      onKeyDown={handleKeyDown}
                      autoFocus
                    />
                  ) : (
                    <b>{item.endcurrentyeardebt}</b>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        ) : (
          <tbody>
            <tr>
              <td colSpan="14" style={{ textAlign: "center" }}>
                <h6>{text}</h6>
              </td>
            </tr>
          </tbody>
        )}
      </Table>
    </Container>
  );
}
